module.exports = __webpack_public_path__ + "static/media/18.754a46c1.jpeg";